import { API, graphqlOperation } from 'aws-amplify';

const fields = `id userID status scope startsAt expiresAt reason grantedBy grantedAt revokedAt createdAt updatedAt`;

const GET = /* GraphQL */ `
  query MemberAccessGet($id: ID!) {
    getMemberAccess(id: $id) { ${fields} }
  }
`;

const LIST = /* GraphQL */ `
  query AdminMemberAccessList($limit: Int, $nextToken: String) {
    listMemberAccesses(limit: $limit, nextToken: $nextToken) {
      items { ${fields} }
      nextToken
    }
  }
`;

const CREATE = /* GraphQL */ `
  mutation AdminMemberAccessCreate($input: CreateMemberAccessInput!) {
    createMemberAccess(input: $input) { ${fields} }
  }
`;

const UPDATE = /* GraphQL */ `
  mutation AdminMemberAccessUpdate($input: UpdateMemberAccessInput!) {
    updateMemberAccess(input: $input) { ${fields} }
  }
`;

const run = async (query, variables = {}) => {
  const response = await API.graphql(graphqlOperation(query, variables));
  return response.data;
};

const unavailable = (error) => (error?.errors || []).some(({ errorType, message }) =>
  errorType === 'FieldUndefined' || /undefined|memberaccess/i.test(message || ''));

export const memberAccessApi = {
  get: async (userID) => {
    if (!userID) return { grant: null, available: true };
    try {
      const data = await run(GET, { id: userID });
      return { grant: data.getMemberAccess || null, available: true };
    } catch (error) {
      if (unavailable(error)) return { grant: null, available: false };
      throw error;
    }
  },

  list: async () => {
    const items = [];
    let nextToken = null;
    try {
      do {
        const data = await run(LIST, { limit: 500, nextToken });
        const page = data.listMemberAccesses;
        items.push(...(page?.items || []).filter(Boolean));
        nextToken = page?.nextToken || null;
      } while (nextToken);
      return { items, available: true };
    } catch (error) {
      if (unavailable(error)) return { items: [], available: false };
      throw error;
    }
  },

  grant: async ({ userID, expiresAt, reason, grantedBy }) => {
    const now = new Date().toISOString();
    const existing = await memberAccessApi.get(userID);
    const input = {
      id: userID,
      userID,
      status: 'ACTIVE',
      scope: 'ALL_CLASSES',
      startsAt: now,
      expiresAt: expiresAt || null,
      reason,
      grantedBy,
      grantedAt: now,
      revokedAt: null,
    };
    if (existing.grant) {
      const data = await run(UPDATE, { input });
      return data.updateMemberAccess;
    }
    const data = await run(CREATE, { input });
    return data.createMemberAccess;
  },

  revoke: async (userID) => {
    const data = await run(UPDATE, { input: { id: userID, status: 'REVOKED', revokedAt: new Date().toISOString() } });
    return data.updateMemberAccess;
  },
};
